angular.module('harriApp')
    .directive('hUsername', ['$filter', function($filter) {
        return {
            restrict:"A",
            require:"ngModel",
            scope:{
                hUsername:'@',
                ngModel:'='
            },
            link: function(scope, element, attr, ngModel) {

                scope.$watch('hUsername', function(newName) {

                    if(ngModel.$dirty && element.val()!="") {
                        return;
                    }

                    newName = newName.split(",");
                    var names = [];

                    for(var k in newName) {
                        if(newName[k]!="") {
                            names.push(newName[k]);
                        }
                    }

                    newName = $.trim(names.join(" "));
                    newName = $filter('username')(newName);

                    ngModel.$setViewValue(newName);
                    ngModel.$setPristine();
                    ngModel.$render();

                    // To trigger validation
                    element.blur();
                });
            }
        };
    }])

    .filter('username', function() {
        return function(text) {
            return publicConfiguration.functions.urlize(text);
        };
    })

    .directive('slugFormatter', ["$filter", function ($filter) {
        return {
            require:'ngModel',
            link: function(scope, element, attrs, ngModel) {

                ngModel.$parsers.push(function(value) {
                    return $filter('username')(value);
                });
            }
        }
    }])


    /*
     <div ng-init="data.work_history=[{listId:0, text:''}]" >
     <div class="form-group"  ng-repeat="work_history in data.work_history" >
     <input auto-increment-field="data.work_history" type="text" ng-model="work_history.text" class="form-control" placeholder="Brand"  />
     </div>
     </div>
     {{data.work_history | json}}
     */
    .directive('autoIncrementField', ['$log', function($log) {
        return {
            restrict: "A",
            link: function(scope, element, attrs) {
                var $dataModel = scope.$eval(attrs.autoIncrementField)

                element.bind("blur", function() {
                    if(element.val()!="" && $dataModel[$dataModel.length-1].text!="") {
                        $dataModel.push({listId: $dataModel.length, text: ''});
                    }

                    scope.$apply();
                });
            }
        };
    }])



    .directive('hMatch', [function () {
        return {
            restrict: 'A',
            scope:true,
            require: 'ngModel',
            link: function (scope, elem , attrs,control) {
                var checker = function () {

                    //get the value of the first password
                    var e1 = scope.$eval(attrs.ngModel);

                    //get the value of the other password
                    var e2 = scope.$eval(attrs.hMatch);
                    return e1 == e2;
                };

                scope.$watch(attrs.ngModel, function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        control.$setValidity("unique", checker());
                        control.$setTouched(true);
                        control.$setDirty(true);
                    }
                });
                scope.$watch(attrs.hMatch, function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        control.$setValidity("unique", checker());
                    }
                });
            }
        };
    }])


    .directive('hMatchValues', function() {
        return {
            require: 'ngModel',
            link:function(scope, element, attrs, ngModel) {

                var checker = function () {

                    //get the value of the first password
                    var e1 = attrs.value1;

                    //get the value of the other password
                    var e2 = attrs.value2;

                    return (e1 == e2 && e1!="") || (e1 == "" && e2 == "");
                };

                var control = ngModel;
                if(attrs.formModel) {
                    control = scope.$eval(attrs.formModel);
                }
                scope.$watch(checker, function (n) {
                    //set the form control to valid if both
                    //passwords are the same, else invalid
                    control.$setValidity("unique", n);
                });

            }
        }
    })



    .filter("maxString", function() {
        return function(str, length) {
            if(str && str.length > 0) {
                if(str.length > length) {
                    return str.substr(0, length-3) + "...";
                } else {
                    return str;
                }
            } else {
                return "";
            }
        }
    })

    .directive('googleAutocomplete', ['googleMaps', '$q', '$timeout', function (googleMaps, $q, $timeout) {
        return {
            restrict: 'A',
            link: function (scope) {
                // Delay the google autocomplete request to at least (minInterval) of milliseconds
                // This is to reduce the number of requests and save quota
                var lastReq = 0;
                var oldResults = [];
                var minInterval = 500; // ms
                var timeoutPromise;

                scope.getAddress = function(location) {
                  var defer = $q.defer();
                  var currentReq = Date.now();
                  var interval = currentReq - lastReq;

                  var requestLocation = function(defer) {
                    lastReq = currentReq;
                    googleMaps.locationAutocomplete(location).then(function(results){
                      oldResults = results;
                      defer.resolve(results);
                    });
                  };

                  if (interval > minInterval) {
                    requestLocation(defer);
                  }
                  else {
                    $timeout.cancel(timeoutPromise);

                    timeoutPromise = $timeout(function(){
                      requestLocation(defer);
                    }, minInterval);

                  }

                  return defer.promise;
                }
            }
        };
    }])


    .directive('googlePlacesAutocompleteElement', ['googleMaps', '$q', '$timeout', function (googleMaps, $q, $timeout) {
      return {
        restrict: 'A',
        link: function (scope, element) {
          // Delay the google autocomplete request to at least (minInterval) of milliseconds
          // This is to reduce the number of requests and save quota
          var lastReq = 0;
          var oldResults = [];
          var minInterval = 500; // ms
          var timeoutPromise;

          scope.getAutocompleteLocation = function(location) {
            var defer = $q.defer();
            var currentReq = Date.now();
            var interval = currentReq - lastReq;

            var requestLocation = function(defer) {
              lastReq = currentReq;

              googleMaps.googlePlacesAutocomplete(location).then(function(results){
                oldResults = results;
                defer.resolve(results);
              });
            };

            if (interval > minInterval) {
              requestLocation(defer);
            }
            else {
              $timeout.cancel(timeoutPromise);

              timeoutPromise = $timeout(function(){
                requestLocation(defer);
              }, minInterval);

            }

            return defer.promise;
          }
        }
      };
    }])

    .directive('setResetPasswordUrlInModel', ['$state', '$parse', function($state, $parse) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var $model = $parse(attrs.ngModel)
                $model.assign(scope, $state.href('homepage.user.resetPasswordToken',{code:null}, { absolute: true}));
            }
        }
    }])

    .directive('paramValue', ['$stateParams', '$parse', function($stateParams, $parse) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var $model = $parse(attrs.ngModel);
                $model.assign(scope, $stateParams[attrs.paramValue]);
            }
        }
    }])

    .directive('contactUs', [function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {

                element.attr('href', "mailto:" + publicConfiguration.support.email);

//                if(deviceChecker.isMobile()) {
//                    element.attr('href', "mailto:" + publicConfiguration.support.email);
//                } else {
//                    element.css('cursor','pointer');
//                    element.click(function(){
//                      try {
//                        LC_API.open_chat_window();
//                      }catch(err) {
//                        console.log('Something Wrong! LC_API not Found!');
//                      }
//                    });
//                }

            }
        }
    }])


  /* Directive to link hide email */
  .directive('hideAccount', [function() {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        element.attr('href', "mailto:feedback@harri.com");
      }
    }
  }])

    /* Custom Directive to force redirect for new Job Posting Button */
    /* the following code is a workaround for the problem, & it should be fixed later */
    /* we have updated ui-route to latest version 0.2.5 */

    .directive('forceCreateJobLink',["$state", function($state) {
        return {
            restrict: 'A',
            link: function(scope, element, attr) {
                element.click(function (e){
                    e.preventDefault();

                    scope.job_id = attr.forceCreateJobLink? attr.forceCreateJobLink:'';
                    hRedirect($state.href('appLayout.harriSH.job_create', {job_id:scope.job_id}));

                });
            }
        }
    }])

    .directive('forceEditJobLink',["$state", function($state) {
      return {
        restrict: 'A',
        scope: {
          'jobid' : '='
        },
        link: function(scope, element, attr) {
          element.click(function (){
            hRedirect($state.href('appLayout.harriSH.job_create', {job_id:scope.jobid}));
          });
        }
      }
    }])

    .constant('convertToUTC', function(inn) {
        if(!inn) return;

        inn = new Date(inn);
        return inn.toUTCString();
    })

    .constant('convertFromUTC', function(out) {
        if(!out) return;
        return new Date(out);
    })

    .constant('copyDate', function(dateFrom, dateTo) {
        if(!dateFrom) {
            dateTo = new Date(dateTo);
            return dateTo;
        } else if(!dateTo) {
            dateFrom = new Date(dateFrom);
            return dateFrom;
        } else {
            dateFrom = new Date(dateFrom);
            dateTo = new Date(dateTo);
        }



        dateTo.setDate(dateFrom.getDate());
        dateTo.setMonth(dateFrom.getMonth());
        dateTo.setYear(dateFrom.getFullYear());

        return dateTo;
    })

    .filter('localTime', function() {
        return function(date) {
            if(!date) return;
            date = new Date(date);
            return date;
        }
    })

    .directive('dateToUtc', ['convertToUTC', 'convertFromUTC', 'copyDate', function(convertToUTC, convertFromUTC, copyDate) {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                copyDate:'=',
                ngModel:'='
            },
            link: function(scope, element, attrs, ctrl) {

                //(model to view)
                ctrl.$formatters.push(function(value) {
                    return convertFromUTC(value);
                });

                //(view to model)
                ctrl.$parsers.push(function(value) {
                    if(!value) {
                        return "";
                    }
                    value = copyDateFromModelToNgModel(scope.copyDate, value);
                    return convertToUTC(value);
                });

                function copyDateFromModelToNgModel(copyFrom, copyTo) {
                    if(attrs.copyDate && (scope.ngModel ||  copyFrom && copyTo)) {
                        var newDate = copyDate(copyFrom, copyTo);
                        copyTo = convertToUTC(newDate);
                    }
                    return copyTo;
                }

                //watch and copy date if changed
                if(attrs.copyDate) {
                    scope.$watch(function () {
                        return scope.copyDate;
                    }, function (value, oldValue) {
                        value = copyDateFromModelToNgModel(scope.copyDate, scope.ngModel);
                        scope.ngModel = convertToUTC(value);
                    });
                }
            }
        }
    }])

//    //convert time to GMT and copy date from another field
//    .directive('ngModelToGmt', ['convertToUTC', 'convertFromUTC', function(convertToUTC, convertFromUTC) {
//        return {
//            restrict: 'A',
//            scope: {
//                copyDate:'=',
//                ngModelToGmt:'=',
//                ngModel:'='
//            },
//            link: function(scope, element, attrs) {
//
//                function converToUTC(inn) {//convertToSecondsFromMicro
//                    return convertToUTC(inn);
//                }
//
//                function convertFromUTC(out) {//convertFromSecondsIntoMicro
//                    return convertFromUTC(out);
//                }
//
//                function copyDate(dateFrom, dateTo) {
//                    dateFrom = new Date(dateFrom);
//                    dateTo = new Date(dateTo);
//
//                    dateTo.setDate(dateFrom.getDate());
//                    dateTo.setMonth(dateFrom.getMonth());
//                    dateTo.setYear(dateFrom.getFullYear());
//
//                    return dateTo;
//                }
//
//                scope.$watch(function() {
//                    return scope.ngModel;
//                }, function(newValue, oldValue) {
//                    //make sure the value was changed before apply the changes
//                    if(newValue && oldValue != newValue && newValue != converToUTC(oldValue)) {
//                        var newDate = newValue;
//
//                        if(attrs.copyDate && scope.copyDate && newValue) {
//                            newDate = copyDate(scope.copyDate, newValue);
//                        }
//
//                        scope.ngModelToGmt = converToUTC(newDate);
//                    }
//                });
//
//                scope.$watch(function() {
//                    return scope.ngModelToGmt;
//                }, function(newValue, oldValue) {
//                    //make sure the value was changed before apply the changes
//                    if(newValue && (oldValue != newValue || scope.ngModel != newValue) && newValue != convertFromUTC(oldValue)) {
//                        scope.ngModel = convertFromUTC(scope.ngModelToGmt)
//                    }
//                });
//
//                if(attrs.copyDate) {
//                    //watch and copy date if changed
//                    scope.$watch(function () {
//                        return scope.copyDate;
//                    }, function (newValue, oldValue) {
//                        if(scope.ngModel) {
//                            var newDate = copyDate(newValue, scope.ngModel);
//                            if (newDate) {
//                                scope.ngModel = newDate;
//                            }
//                        }
//                    });
//                }
//            }
//        }
//    }])

    //loop through media object and get background and image instance
    .constant('coverAndProfileImagesOf', function(media) {
        var bg = null;
        var profile = null;

        if(media) {
            for(var mediaKey in media) {
                if(media[mediaKey]['type'] == 'background_image') {
                    bg = media[mediaKey];
                    delete media[mediaKey];
                } else if(media[mediaKey]['type'] == 'profile_image') {
                    profile = media[mediaKey];
                    delete media[mediaKey];
                }

                if(bg && profile) {
                    break;
                }
            }
        }

        return {cover: bg || {}, icon: profile || {}};
    })


    .directive('oneCheckedAtleast', ["$timeout", function($timeout) {
        return {
            require: 'ngModel',
            link: function(scope, elm, attrs, ctrl) {

                var formName = elm.closest('form').attr("name");
                var form = scope.$eval(formName);
                var isRadio = elm.attr("type")=="radio";

                scope.$on('show-errors-check-validity', function () {
                    if (!elm.is(':visible')) {
                      // If element is not vsible - do nothing
                      return true;
                    }

                    var validity = checkValidity(getCheckboxValues());
                    setValidity(validity);

                    $timeout(function() {
                        setValidity(validity);
                        scope.$apply();
                    });

                    return validity;
                });

                function checkValidity(newValue) {
                    if(isRadio) {
                        var findFalseOrUndefined = _.find(newValue, function(value){ return value!==false && value!=undefined; });
                        return (findFalseOrUndefined===false || findFalseOrUndefined==undefined)? false : true;
                    } else {
                        return _.find(newValue, function(value){ return value==true || value == 1; }) == true;
                    }
                }

                function getCheckboxValues() {
                    return scope.$eval(attrs.oneCheckedAtleast)
                }

                function setValidity(validity) {
                    ctrl.$setValidity('oneCheckedAtleast', validity);
                    return validity;
                }

                scope.$watchCollection(getCheckboxValues, function(newValue, oldValue) {
                    if(form.$dirty) {
                      setValidity(checkValidity(newValue));
                    }
                });


            }
        };
    }])

    /* validate comm seprated emails on single input filed */
    .directive('multipleEmails', function () {
      return {
        require: 'ngModel',
        link: function(scope, element, attrs, ctrl) {

         //src= https://github.com/angular/angular.js/blob/master/src/ng/directive/input.js#L4

         var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

          ctrl.$parsers.unshift(function(viewValue) {
            if($.trim(viewValue) == ""){
                ctrl.$setValidity('multipleEmails', true);
                return viewValue;
            }

            var emails = viewValue.split(',');

              var validityArr = emails.map(function(str){
                  return EMAIL_REGEXP.test(str.trim());
              }); // sample return is [true, true, true, false, false, false]
              var atLeastOneInvalid = false;
              angular.forEach(validityArr, function(value) {
                if(value === false)
                  atLeastOneInvalid = true;
              });
              if(!atLeastOneInvalid) {
                ctrl.$setValidity('multipleEmails', true);
                return viewValue;
              } else {
                ctrl.$setValidity('multipleEmails', false);
                return undefined;
              }

          });
        }
      };
    })

    .directive('removeElement', ['$log', 'httpHelper', function($log, httpHelper) {
        return {
            scope:{
                'removeElement':'=',
                'element':'=',
                'removeApi':'@'
            },
            restrict: "A",
            link: function(scope, element, attrs) {
                if(!attrs.element) {
                    $log.error("removeElement must has a valid element attribute");
                }

                element.bind("click", function() {
                    var index = parseInt(scope.removeElement);
                    if(scope.element[index].apiDelete && scope.removeApi) {
                        httpHelper.g(scope.removeApi + scope.element[index].id)
                    }

                    scope.element.splice(index, 1);
                    scope.$apply();
                });
            }
        };
    }])


//    .directive('validateEmpty', function() {
//        return {
//            require: '^form',
//            link: function (scope, element, attrs, formContr) {
//
//                var formElementName = attrs.formElementValidity;
//
//                if(!formElementName) {
//                    formElementName = attrs.validateEmpty;
//                }
//
//                var modelStructure = formElementName.split('.');
//                var compounent = formContr[modelStructure[1]][modelStructure[2]];
//
//                function validate() {
//                    var valid = (!compounent.$viewValue || (angular.isArray(compounent.$viewValue) && compounent.$viewValue.length == 0))
//                    compounent.$setValidity('empty', valid);
//                }
//
//                scope.$on('show-errors-check-validity', function () {
//                    validate();
//                });
//
//                scope.$on('show-errors-reset', function () {
//                    compounent.$setValidity('empty', true);
//                });
//
//                scope.$watch(function() { scope.$eval(attrs.validateEmpty) }, function(n) {
//                    if(n==undefined) return;
//                    validate();
//                });
//
//            }
//        }
//    })

    .directive('hRequired', function() {
        return {
            require:'ngModel',
            link: function(scope, element, attrs, contr) {

                scope.$watch(function() {
                    return contr.$viewValue
                }, function(n) {
                    contr.$setValidity('required', !(!n));
                });

//                return;
//
//                var modelStructure = attrs.hRequired;
//                modelStructure = modelStructure.split('.');
//                var formName = modelStructure[1];
//                var elementName = modelStructure[2];
//
//
//
//                scope.forms[formName][elementName].$setValidity('required', false);
//
//                return;
//
//                scope.$on('show-errors-reset', function () {
//                    $(element).removeClass('has-error');
//                });
//
//                scope.$on('show-errors-check-validity', function () {
//                    validate(true);
//                });
//
//                $(element).find('input').blur(function() {
//                    scope.$apply(function() {
//                        validate(true)
//                    })
//                });
//
//                function validate(validateEmpty, value) {
//                    if(!value) {
//                        value = scope.hRequired;
//                    }
//
//                    if(validateEmpty && (!value || (angular.isArray(value) && value.length==0))) {
//                        $(element).addClass('has-error');
//                    } else {
//                        $(element).removeClass('has-error');
//                    }
//                }
//
//                scope.$watch(function() { return scope.hRequired; }, function(n) {
//                    validate(false, n)
//                });

            }
        }
    })

    .directive('enterToAddTo', ['$parse', '$timeout', 'autoCompleteListTemplate', function($parse, $timeout, autoCompleteListTemplate) {
        return {
            require:'ngModel',
            scope: {
                'ngModel': '=',
                'enterToAddTo': '='
            },
            link: function(scope, element, attrs, cont) {

//                //list to changes based on Enter event
//                element.keypress(function(e) {
//                    //this only works if the user enters a String
//                    if(e.keyCode == 13) {
//                        e.preventDefault();
//                        $timeout(addToList);
//                    }
//                });

                //Angular strap typeahead has no callbacks
                //We listen to changes if selection was changed
                //Strings listen to Enter action because list is now shown
                scope.$watch(function() {

                    return scope.ngModel;

                }, function(newValue){
                    //add the value if only and only if it has value
                    if(newValue) {
                        addToList(true);
                    }

                });

                function addToList(isObejct) {

                    var selectedValue = scope.ngModel;
                    if(!selectedValue) {
                        //discart empty strings
                        return;
                    }


                    if(selectedValue && attrs.newEntryKey && selectedValue[attrs.newEntryKey]) {
                        //creating a new value for Strings similar to structure of other values
                        var label = selectedValue[attrs.newEntryKey];
                        selectedValue = {value: label, label: autoCompleteListTemplate({name:label, address:'&nbsp;'}), type:"string"};
                    }

                    //set input model value to ''
                    scope.ngModel = '';
//                    cont.$setViewValue('')

                    //set input model value to ''
                    if(!scope.enterToAddTo || scope.enterToAddTo.length == 0) {
                        scope.enterToAddTo = [];
                    }

                    //add value to the list
                    scope.enterToAddTo.push(selectedValue);
                }
            }
        }
    }])

    .constant('autoCompleteListTemplate', function(params) {
        if(!params.address) {
            params.address = '&nbsp;';
        }
        return _.template("<strong><%= name %></strong> <span class='hidden'>at</span><br/> <small><%= address %></small>")(params);
    })

    .directive("t", ["$timeout",function($timeout) {
        return {
            "link": function(scope) {
                $timeout(function() {
                    scope.t = [{value:2, name:"3"}]
                }, 5000)
            }
        }
    }])
    .directive('disableCopyPast', function() {
        return {
            link: function(scope, element, attrs) {
                element.bind("cut copy paste",function(e) {
                    e.preventDefault();
                });
            }
        }
    })
    .directive('disableKeyboard',function(){
      return  {
        link: function( scope, element, attrs ){
          element.bind('keypress keyup keydown',function(e){
            e.preventDefault();
          });
        }
      }
    })
    .directive('disableSelection',function (){
      return {
        link: function (scope,element,attrs){
          element.attr('unselectable','on')
            .css({'-moz-user-select':'-moz-none',
              '-moz-user-select':'none',
              '-o-user-select':'none',
              '-khtml-user-select':'none',
              '-webkit-user-select':'none',
              '-ms-user-select':'none',
              'user-select':'none'
            }).bind('selectstart', function(){ return false; });
        }
      }
    })
    .directive('phoneValidator', function() {
        return {
            require:'ngModel',
            link: function($scope, element, attrs, ngModel) {
                if(!$scope.phoneNumberPattern)
                    $scope.phoneNumberPattern = (function() {
                        var regexp = Utils.getPhoneRegx();
                        return {
                            test: function(value) {
                                if( $scope.requireTel === false ) {
                                    return true;
                                }

                                var minLength = attrs.minlength || attrs.ngMinlength;

                                if (minLength) {
                                    // exclude all characters expect numbers
                                    var cleanValue = value.replace(/[\(,\),\-,\ ,\+,\.]/g, '');
                                    if (cleanValue.length < minLength) {
                                      return false;
                                    }
                                }

                                return regexp.test(value);
                            }
                        };
                    })();
            }
        }
    })

    .directive('onlyDigits', function () {

      return {
        restrict: 'A',
        require: '?ngModel',
        link: function (scope, element, attrs, ngModel) {
          if (!ngModel) return;
          ngModel.$parsers.unshift(function (inputValue) {
            var digits = inputValue.split('').filter(function (s) { return (!isNaN(s) && s != ' '); }).join('');
            ngModel.$viewValue = digits;
            ngModel.$render();
            return digits;
          });
        }
      };
    })

    .directive('makeSlug', function () {

      return {
        restrict: 'A',
        require: '?ngModel',
        link: function (scope, element, attrs, ngModel) {
          if (!ngModel) return;
          element.off('post keypress keydown change keyup');
          element.on('post keypress keydown change keyup', function( e ){
            var val = element.val().replace(/[^A-Z0-9]+/ig, "-");
            ngModel.$viewValue = val;
            ngModel.$render();
          });
        }
      };
    })

    .directive('moveFormUp', ['hFormReference', 'registrationApi', function(hFormReference, registrationApi) {
        return {
            link: function(scope, element) {

                hFormReference.current(element, {
                    beforeActive: function(scope) {
                        element.closest('.modal').animate({scrollTop:0},{duration:0});
                    }
                })
            }
        }
    }])


    .directive('applySlug', function () {
      return {
        restrict: 'A',
        scope: {
          'slug': '=',
          ngModel: '='
        },

        link: function (scope) {
          scope.$watch('slug', function(newValue, oldValue) {
              var returnValue = "";
              if(newValue && newValue!=""){
                returnValue = newValue.replace(/[^A-Z0-9]+/ig, "-");
              }else if(newValue && newValue == ""){
                returnValue = "";
              }else if(newValue && newValue == " "){
                returnValue = "";
              }
              scope.ngModel = returnValue;
          });
        }
      };
    })
    /* force trimming trailing and leading white spaces from input
    -----------
     */
    .directive('hTrim', [function () {
    return {
      restrict: 'A',
      require: '^form',
      link: function(scope, elem, attrs, control){
        var passEl = elem;
        if(!passEl.is( "input" )){
          passEl = elem.find('input');
        }

        if(passEl){
          passEl.change(function(){
            $timeout(function(){
              scope.$apply(function(){
                var newTrimedValue = passEl.val().trim();
                /*
                 some cases the model doesn't take the new value, in this way we force it to accept the new trimmed value
                 */
                if(control[passEl.attr('name')] && typeof control[passEl.attr('name')].$setViewValue === 'function' ){
                    control[passEl.attr('name')].$setViewValue(newTrimedValue);
                }
                /* display the new trimmed valeu in the input field */
                passEl.val(newTrimedValue);
              });
            })
          })
        }

      }
    };
  }])


/*
* Login Link Directive (a link which will show the login modal)
*/
.directive('loginLink', ['hFormReference', 'hTransitions', function (hFormReference, hTransitions) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
        element.off('click')
            .on('click', function (e) {
                hRedirect('/user/login');
            });
    }
  }
}])


/*
 * Forget Password Directive
 * used in login form view, it changes the form scope to reset/password without the need to reload the form
 * or moveing to the reset password state
 */
.directive('forgetPasswordLink', ['hFormReference',function(hFormReference) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {

      element.off('click')
        .on('click',function(e){

          /* show login form where sometimes the reset modal was used before */
          hFormReference.getForm("login").then(function (formObj) {
              formObj.scope.goto('reset_password/enter_email');
          });


        });



    }
  }
}]);
